<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">企业账号管理</a></li>
                <li><a href="#">充值划账记录</a></li>
            </ul>
        </div>

        <div class="formbody">
            <div class="formtitle"><span>划账记录</span></div>
            <div id="usual1" class="usual"> 
                <div id="tab1" class="tabson">                
                    <table class="tablelist">
                        <thead>
                            <tr>								
                                <th>门牌号</th>
                                <th>描述</th>
                                <th>划账金额</th>
                                <th>注册时间</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(item, index) in list" :class="{odd:index%2!=0}">
                                <td>{{item.account}}</td>
                                <td>{{item.subject}}</td>
                                <td>{{item.money}}</td>
                                <td>{{item.createtime.split('.')[0]}}</td>
                            </tr>     
                        </tbody>
                    </table>

                    <div class="pagin">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pageIndex"
                            :page-sizes="[pageSize]"
                            :page-size="50"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalCount">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <!-- 查询等待 -->
        <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
            top: 0; left: 0;display: block;" v-show="loadingShow"></div>
        <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
            -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
            <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
            <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
        </div>

    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    data() {
        return {
            list: [],
            pageIndex: 1,
            pageSize: 50,
            totalCount: 0,
            loadingShow: true,
        }
    },
    components : {
        'v-cookie' : cookie,
    },
    mounted() {
        this.pageChange(1)
    },
    methods: {
        handleSizeChange(val) {
            this.pageChange(val)
        },
        handleCurrentChange(val) {
            this.pageChange(val)
        },
        pageChange(pageIndex) {
            this.loadingShow = true;
            var that = this
            let data = {'pageIndex': pageIndex, 'pageSize': this.pageSize}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/enterprise/enterprisexpaysuccess.json",
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if(res.data.code == '0000000')
                {
                    that.list = res.data.xpaysuccessList;
                    that.pageIndex = res.data.page.pageIndex;
                    that.pageSize = res.data.page.pageSize;
                    that.totalCount = res.data.page.totalCount;
                    that.loadingShow = false;
                }
                else
                {
                    alert(res.data.msg)
                    return false;
                }
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/enterprise/enterprisexpaysuccess.vue